import * as React from 'react';
import classnames from 'classnames';
import { CnBalloon } from '@alife/cn-ui';
import keyboardEvent from '../event';
import './index.scss';
export default function Switch(props) {
    const { value, text, hotKey, readOnly, onChange, className, size = 'small', balloon = {}, ...others } = props;
    const doChange = React.useCallback((e) => {
        onChange instanceof Function && onChange(!value, e);
    }, [value, onChange]);
    React.useEffect(() => {
        if (hotKey && !readOnly && onChange) {
            const formatHotKey = hotKey.toLocaleLowerCase();
            keyboardEvent.bind(formatHotKey, doChange);
            return () => {
                keyboardEvent.unbind(formatHotKey, doChange);
            };
        }
        return () => { };
    }, [hotKey, readOnly, onChange, doChange]);
    const switchBtn = (React.createElement("div", { "data-hottag": 'cn-op.switch', className: classnames('op-switch', `op-switch-${size}`, className), ...others }, readOnly ? (value && React.createElement("span", { className: 'op-switch-label' }, text ?? '')) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classnames('op-switch-inner', `op-switch-inner-${value ? 'on' : 'off'}`), onClick: doChange },
            React.createElement("div", { className: 'op-switch-inner-btn' })),
        text && (React.createElement("span", { className: 'op-switch-label' },
            text ?? '',
            hotKey ? `[${hotKey}]` : ''))))));
    const { children: balloonChildren, ...rest } = balloon;
    return balloonChildren ? (React.createElement(CnBalloon, { v2: true, className: 'op-balloon', triggerType: 'hover', align: 'tl', closable: false, trigger: switchBtn, ...rest }, balloonChildren)) : (switchBtn);
}
